/**
 * @example
 * <table>
 *   <!-- @beforeEnter, @enter, @leave イベントでtableRowAnimatorの関数を呼び出す -->
 *   <tbody is="transition-group"
 *       :css="false"
 *       @before-enter="$_tableRowAnimator_beforeEnter"
 *       @before-leave="$_tableRowAnimator_beforeLeave"
 *       @enter="$_tableRowAnimator_enter"
 *       @leave="$_tableRowAnimator_leave">
 *     <tr key="header">
 *       <th>No</th>
 *       <th>Name</th>
 *     </tr>
 *     <tr key="row1">
 *       <!-- tableRowAnimatorはtd直下のdivの高さを変えるため、tdの中にはdivを入れる -->
 *       <td><div>1</div></td>
 *       <td><div>Gerard</div></td>
 *     </tr>
 *     <tr key="row2">
 *       <td><div>2</div></td>
 *       <td><div>Potter</div></td>
 *     </tr>
 *   </tbody>
 * </table>
 */

import _ from 'lodash'
import velocity from 'velocity-animate'

const DURATION = 300

function animateRowsBackgroundColor (row, isEnter, cancelAnimation) {
  let parent = row.parentElement
  let rowIndex = Array.from(parent.childNodes).findIndex(element => element === row)
  // nth-childは1オリジンのため、rowより後の要素を取得するためにはindex+2とする必要がある
  let sibling = parent.querySelectorAll(`tr:nth-child(n + ${rowIndex + 2})`)
  sibling.forEach((element, index) => {
    let goalPosition = rowIndex + index + 1 + (isEnter ? 1 : 0)
    velocity(
      element,
      { backgroundColor: goalPosition % 2 === 0 ? '#f2fbfc' : '#ffffff' },
      {
        duration: cancelAnimation ? 0 : DURATION,
        complete: elements => {
          elements[0].style.removeProperty('background-color')
        }
      }
    )
  })
}

export default {
  data () {
    return {
      $_tableRowAnimator_cancelAnimation: true
    }
  },
  methods: {
    $_tableRowAnimator_beforeEnter (el) {
      let divs = el.querySelectorAll('td>div')
      for (let i = 0; i < divs.length; i++) {
        divs[i].style.maxHeight = '0px'
      }
    },
    $_tableRowAnimator_beforeLeave (el) {
      let divs = el.querySelectorAll('td>div')
      let max = _.maxBy(divs, element => {
        return element.clientHeight
      }).clientHeight
      for (let i = 0; i < divs.length; i++) {
        divs[i].style.maxHeight = max + 'px'
      }
    },
    $_tableRowAnimator_enter (el, done) {
      animateRowsBackgroundColor(el, true, this.$_tableRowAnimator_cancelAnimation)
      let divs = el.querySelectorAll('td>div')
      let paddingTop = window.getComputedStyle(divs[0]).getPropertyValue('padding-top')
      let paddingBottom = window.getComputedStyle(divs[0]).getPropertyValue('padding-bottom')
      for (let i = 0; i < divs.length; i++) {
        divs[i].style.paddingTop = '0px'
        divs[i].style.paddingBottom = '0px'
      }
      velocity(
        divs,
        { maxHeight: 500, paddingTop: paddingTop, paddingBottom: paddingBottom },
        {
          easing: 'easeInOutCirc',
          duration: this.$_tableRowAnimator_cancelAnimation ? 0 : DURATION,
          complete: done
        }
      )
      this.qtyDetailVisibilityChange = false
    },
    $_tableRowAnimator_leave (el, done) {
      animateRowsBackgroundColor(el, false, this.$_tableRowAnimator_cancelAnimation)
      let divs = el.querySelectorAll('td>div')
      velocity(
        divs,
        { maxHeight: '0px', paddingTop: 0, paddingBottom: 0 },
        {
          easing: 'easeInOutCirc',
          duration: this.$_tableRowAnimator_cancelAnimation ? 0 : DURATION,
          complete: done
        }
      )
      this.qtyDetailVisibilityChange = false
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/mixins/tableRowAnimator.js